// extracted by mini-css-extract-plugin
module.exports = {"clean-table-wrapper":"DynamicTable_clean-table-wrapper__4wpQn","table-container":"DynamicTable_table-container__IDNbu","styled-table":"DynamicTable_styled-table__eyHLY"};